


import {
    createSelector, createSlice,
} from "@reduxjs/toolkit";
import { RequestStatus } from "Model/Enums";
import { IAppState } from "Store/store";
import { getPendingApprovals1Thunk, getApprovalDetails1Thunk, postDeleteApprovals1Thunk, deleteApprovals1Thunk, systemSlice1Reducer, ISystemSlice1State } from "Store/SystemTemplate/SystemSlice1";

export const accessApprovalsInitialState: ISystemSlice1State = {
    pendingApprovalsStatus: RequestStatus.Idle,
    pendingApprovalsError: null,
    selectedApprovalDetailStatus: RequestStatus.Idle,
    selectedApprovalDetailError: null,
    supportMulti: false,
    selectedApproval: null,
    selectedApprovalDetails: null,
    multiSelectedApprovals: [],
    searchQuery: "",
    isAsc: false,
    selectedSubSystem: null,
    fromPosition: 0,
    subSystems: [],
    totalCountForFilter: 0,
    pendingApprovals: [],
    isTabletView: false,
};

const accessApprovalsSlice = createSlice({
    name: "AccessApprovals",
    initialState: accessApprovalsInitialState,
    reducers: systemSlice1Reducer
});

export const GetPendingApprovals = getPendingApprovals1Thunk(accessApprovalsInitialState, accessApprovalsSlice, "AccessApprovals", "AccessApprovals");
export const GetApprovalDetails = getApprovalDetails1Thunk(accessApprovalsSlice, "AccessApprovals", "AccessApprovals");
export const PostDeleteApprovals = postDeleteApprovals1Thunk(accessApprovalsSlice, "AccessApprovals");
export const DeleteApprovals = deleteApprovals1Thunk(accessApprovalsSlice, "AccessApprovals", "AccessApprovals");

// Action
export const {
    resetSystemSliceState,
    setPendingApprovalsStatus,
    setSelectedApproval,
    setSelectedApprovalDetails,
    setMultiSelectedApprovals,
    setSearchQuery,
    setIsAsc,
    setSelectedSubSystem,
    setFromPosition,
    setSubSystems,
    setTotalCountForFilter,
    setPendingApprovals,
    addToPendingApprovals,
    reCalculateSelectedApproval,
    setIsTabletView,
} = accessApprovalsSlice.actions;

// Selector
export const AccessApprovalsSelector = (state: IAppState) => state.AccessApprovals;
export const PendingApprovalsStatusSelector = createSelector(
    AccessApprovalsSelector,
    (details) => details?.pendingApprovalsStatus
);
export const PendingApprovalsErrorSelector = createSelector(
    AccessApprovalsSelector,
    (details) => details?.pendingApprovalsError
);
export const SelectedApprovalDetailStatusSelector = createSelector(
    AccessApprovalsSelector,
    (details) => details?.selectedApprovalDetailStatus
);
export const SelectedApprovalDetailErrorSelector = createSelector(
    AccessApprovalsSelector,
    (details) => details?.selectedApprovalDetailError
);
export const SupportMultiSelector = createSelector(
    AccessApprovalsSelector,
    (details) => details?.supportMulti
);
export const SelectedApprovalSelector = createSelector(
    AccessApprovalsSelector,
    (details) => details?.selectedApproval
);
export const SelectedApprovalDetailsSelector = createSelector(
    AccessApprovalsSelector,
    (details) => details?.selectedApprovalDetails
);
export const MultiSelectedApprovalsSelector = createSelector(
    AccessApprovalsSelector,
    (details) => details?.multiSelectedApprovals
);
export const SearchQuerySelector = createSelector(
    AccessApprovalsSelector,
    (details) => details?.searchQuery
);
export const IsAscSelector = createSelector(
    AccessApprovalsSelector,
    (details) => details?.isAsc
);
export const SelectedSubSystemSelector = createSelector(
    AccessApprovalsSelector,
    (details) => details?.selectedSubSystem
);
export const FromPositionSelector = createSelector(
    AccessApprovalsSelector,
    (details) => details?.fromPosition
);
export const SubSystemsSelector = createSelector(
    AccessApprovalsSelector,
    (details) => details?.subSystems
);
export const TotalCountForFilterSelector = createSelector(
    AccessApprovalsSelector,
    (details) => details?.totalCountForFilter
);
export const PendingApprovalsSelector = createSelector(
    AccessApprovalsSelector,
    (details) => details?.pendingApprovals
);
export const IsTabletViewSelector = createSelector(
    AccessApprovalsSelector,
    (details) => details?.isTabletView
);

export const AccessApprovalsReducer = accessApprovalsSlice.reducer;
